import { render, staticRenderFns } from "./choice.vue?vue&type=template&id=2c1bca4a"
import script from "./choice.vue?vue&type=script&lang=ts"
export * from "./choice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports